// This file is generated by @showell-labs/env.

export const targetEnv = "dev";

export const SHW_ENV = {
  SHW_ADMIN_URL: "https://staging.showellapp.com",
  SHW_API_URL: "https://staging-api.showellapp.com",
  SHW_AI_SEARCH_URL: "https://staging2-api.showellapp.com/ai-search/prompt",
  SHW_MESSAGING_URL: "https://staging2-api.showellapp.com/messaging",
  SHW_AI_ASSISTANT_BASE_URL: "https://staging2-api.showellapp.com/ai-assistant",
  SHW_AI_ASSISTANT_AGENT_ID: "ai-assistant-agent",
  SHW_TRANSLATION_MANAGER_URL: "https://umgh204x88.execute-api.eu-central-1.amazonaws.com/dev",
  SHW_ANALYTICS_URL: "https://staging2-api.showellapp.com/analytics",
  SHW_LMS_URL: "https://staging2-api.showellapp.com/lms",
  SHW_LAMBDA_HELPERS_URL: "https://d2vq86iohky2ka.cloudfront.net",
  SHW_SMART_TOOL_DEPLOY_URL: "https://00noeia4f5.execute-api.eu-central-1.amazonaws.com/smart-tools",
  SHW_APP_URL: "https://alpha.showellapp.com",
  SHW_SHOWELL_DOMAIN_SUFFIX: ".staging.showell.app",
  SHW_SHARE_CENTER_URL: "https://staging-shares.showellapp.com",
  SHW_OUTLOOK_ADD_IN_URL: "https://outlook-staging.showell.com",
  SHW_OUTLOOK_APP_URL: "https://outlook-staging.showellapp.com",
  SHW_OUTLOOK_ADDIN_LAMBDA_URL: "https://ul9tree3u9.execute-api.eu-central-1.amazonaws.com/dev",
  SHW_POWERPOINT_ADD_IN_URL: "https://powerpoint-staging.showell.com",
  SHW_POWERPOINT_APP_URL: "https://powerpoint-staging.showellapp.com",
  SHW_CHARGEBEE_SITE: "showell-test",
  SHW_SENTRY_APP_DSN: "https://4ffcf4094a99ab7c8d5d6565d08fb517@o4510896352788480.ingest.de.sentry.io/4510896454238288",
  SHW_SENTRY_APP_ENVIRONMENT: "staging",
  SHW_SENTRY_SSC_DSN: "https://be3562abb8f6f78820032753a32ffc3f@o4510896352788480.ingest.de.sentry.io/4510896454041680",
  SHW_SENTRY_SSC_ENVIRONMENT: "staging",
  SHW_SENTRY_ANALYTICS_DSN: "https://d979b7b4a6ff4203b27a7675b6852f25@o4510896352788480.ingest.de.sentry.io/4510896447815760",
  SHW_SENTRY_ANALYTICS_ENVIRONMENT: "dev",
  SHW_SENTRY_MESSAGING_DSN: "https://fe6e54830f7359d7f766dcd755d9144c@o4510896352788480.ingest.de.sentry.io/4510896453910608",
  SHW_SENTRY_MESSAGING_ENVIRONMENT: "dev",
  SHW_SENTRY_LMS_DSN: "https://eee28b8103be2eeccb28152734815280@o4510896352788480.ingest.de.sentry.io/4510896453779536",
  SHW_SENTRY_LMS_ENVIRONMENT: "dev",
  SHW_VERSION_CODE: "0",
  SHW_APP_NAME_SUFFIX: " DEV",
  SHW_APP_S3_RELEASE_BUCKET: "showell-releases",
  SHW_APP_S3_REGION: "eu-central-1",
  SHW_E2E_RUNTIME_ENABLED: "true",
};